import { render } from "./2024Results.vue?vue&type=template&id=391e6571&scoped=true"
import script from "./2024Results.vue?vue&type=script&lang=js"
export * from "./2024Results.vue?vue&type=script&lang=js"

import "./2024Results.vue?vue&type=style&index=0&id=391e6571&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shawn\\sloppy-golf\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391e6571"]])

export default __exports__